import { combineReducers } from 'redux';
import JobPricingGridReducer from '../JobPricingDetails/JobPricingGrid/JobPricingGridCreate';
import CompensationSummaryGridReducer from '../JobPricingDetails/JobPricingGrid/CompensationSummaryJobPricingGridCreate';
import {
  GET_PRICING_DETAILS_VIEWS_START,
  GET_PRICING_DETAILS_VIEWS_SUCCESS,
  GET_PRICING_DETAILS_VIEWS_ERROR,
  SET_PRICING_DETAILS_SELECTED_VIEW_START,
  SET_PRICING_DETAILS_SELECTED_VIEW_SUCCESS,
  SET_PRICING_DETAILS_SELECTED_VIEW_ERROR,
  GET_PRICING_DETAILS_SELECTED_VIEW_START,
  GET_PRICING_DETAILS_SELECTED_VIEW_SUCCESS,
  GET_PRICING_DETAILS_SELECTED_VIEW_ERROR,
  GET_LAST_MODIFIED_DATE_SUCCESS,
  GET_LAST_MODIFIED_DATE_ERROR,
  RESET_JOB_PRICING_REDUCER,
  SET_SELECTED_AGING_FACTOR,
  SET_SELECTED_BENCHMARK_YEAR,
  UPDATE_AGING_FACTOR_FAILED,
  UPDATE_AGING_FACTOR_START,
  UPDATE_AGING_FACTOR_SUCCESS,
  UPDATE_MERIT_MATCH_SUMMARIES_FAILED,
  UPDATE_MERIT_MATCH_SUMMARIES_START,
  UPDATE_MERIT_MATCH_SUMMARIES_SUCCESS,
  GET_PRICING_SURVEY_LIST,
  GET_PRICING_SURVEY_LIST_SUCCESS,
  GET_PRICING_SURVEY_LIST_ERROR,
  ADD_SELECTED_CUT_ID,
  REMOVE_SELECTED_CUT_ID,
  GET_PRICING_DETAILS_RANGE_CHART_DATA_START,
  GET_PRICING_DETAILS_RANGE_CHART_DATA_SUCCESS,
  GET_PRICING_DETAILS_RANGE_CHART_DATA_ERROR
} from './JobPricingActions';

const initialState = {
  selectedCutIDs: [],
  selectedSlottedJobs: [],
  selectedJob: null,
  pricingViews: [],
  slottedViews: [],
  setSelectedPricingViewSuccess: false,
  setSelectedPricingViewFailed: false,
  selectedViewPk: null,
  selectedViewSlottedPk: null,
  isRetrievingSelectedView: false,
  salaryRanges: [],
  currency: null,
  isCurrencyLoading: false,
  salaryRange: null,
  isSalaryRangesLoading: false,
  careerLevel: null,
  jobFamily: null,
  selectedAgingFactor: null,
  isUpdatingAgingFactor: false,
  isUpdatingAgingFactorFailed: false,
  selectedBenchmarkYear: null,
  isUpdatingMeritMatchSummaries: false,
  isUpdatingMeritMatchSummariesFailed: false,
  lastModifiedDate: null,
  isLoading: true,
  rangeChartData: {},
  rangeChartLoading: false,
  rangeChartLoaded: false,
  rangeChartError: false,
  pricingDefaultViewId: null,
  slottedDefaultViewId: null
};

function JobPricingReducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_PRICING_DETAILS_VIEWS_SUCCESS: {
      if (action.isSlotted) {
        return {
          ...state,
          slottedViews: action.pricingViews,
          slottedDefaultViewId: action.defaultViewId
        };
      }

      return {
        ...state,
        pricingViews: action.pricingViews,
        pricingDefaultViewId: action.defaultViewId
      };
    }
    case SET_PRICING_DETAILS_SELECTED_VIEW_START: {
      return {
        ...state,
        setSelectedPricingViewFailed: false,
        setSelectedPricingViewSuccess: false
      };
    }
    case SET_PRICING_DETAILS_SELECTED_VIEW_SUCCESS: {
      if (action.isSlotted) {
        return {
          ...state,
          setSelectedPricingViewFailed: false,
          setSelectedPricingViewSuccess: true,
          selectedViewSlottedPk: action.selectedViewPk
        };
      }

      return {
        ...state,
        setSelectedPricingViewFailed: false,
        setSelectedPricingViewSuccess: true,
        selectedViewPk: action.selectedViewPk
      };
    }
    case SET_PRICING_DETAILS_SELECTED_VIEW_ERROR: {
      return {
        ...state,
        setSelectedPricingViewFailed: true,
        setSelectedPricingViewSuccess: false
      };
    }
    case GET_PRICING_DETAILS_SELECTED_VIEW_START: {
      return {
        ...state,
        isRetrievingSelectedView: true
      };
    }
    case GET_PRICING_DETAILS_SELECTED_VIEW_SUCCESS: {
      if (action.isSlotted) {
        return {
          ...state,
          isRetrievingSelectedView: false,
          selectedViewSlottedPk: action.selectedViewPk
        };
      }

      return {
        ...state,
        isRetrievingSelectedView: false,
        selectedViewPk: action.selectedViewPk
      };
    }
    case SET_SELECTED_AGING_FACTOR: {
      return {
        ...state,
        selectedAgingFactor: action.agingFactor ? action.agingFactor : state.agingFactor
      };
    }
    case UPDATE_AGING_FACTOR_START: {
      return {
        ...state,
        isUpdatingAgingFactor: true
      };
    }
    case UPDATE_AGING_FACTOR_SUCCESS: {
      return {
        ...state,
        isUpdatingAgingFactor: false,
        isUpdatingAgingFactorFailed: false,
        selectedAgingFactor: action.agingCode
      };
    }
    case UPDATE_AGING_FACTOR_FAILED: {
      return {
        ...state,
        isUpdatingAgingFactor: false,
        isUpdatingAgingFactorFailed: true
      };
    }
    case SET_SELECTED_BENCHMARK_YEAR: {
      return {
        ...state,
        selectedBenchmarkYear: action.benchmarkYear
      };
    }
    case UPDATE_MERIT_MATCH_SUMMARIES_START: {
      return {
        ...state,
        isUpdatingMeritMatchSummaries: true
      };
    }
    case UPDATE_MERIT_MATCH_SUMMARIES_SUCCESS: {
      return {
        ...state,
        isUpdatingMeritMatchSummaries: false,
        isUpdatingMeritMatchSummariesFailed: false
      };
    }
    case UPDATE_MERIT_MATCH_SUMMARIES_FAILED: {
      return {
        ...state,
        isUpdatingMeritMatchSummaries: false,
        isUpdatingMeritMatchSummariesFailed: true
      };
    }
    case RESET_JOB_PRICING_REDUCER: {
      return {
        ...initialState
      };
    }
    case GET_LAST_MODIFIED_DATE_SUCCESS: {
      return {
        ...state,
        lastModifiedDate: action.lastModifiedDate || 0
      };
    }
    case GET_LAST_MODIFIED_DATE_ERROR: {
      return {
        ...state,
        lastModifiedDate: null
      };
    }
    case GET_PRICING_SURVEY_LIST: {
      return {
        ...state,
        isLoading: true
      };
    }
    case GET_PRICING_SURVEY_LIST_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        selectedSlottedJobs: action.selectedSlottedJobs || [],
        selectedCutIDs: action.selectedCutIDs || []
      };
    }
    case GET_PRICING_SURVEY_LIST_ERROR: {
      return {
        ...state,
        // TODO: Add error state
        isLoading: false
      };
    }
    case ADD_SELECTED_CUT_ID:
      return {
        ...state,
        selectedCutIDs: [
          // Set makes sure the elements are unique and there are no duplicates
          ...new Set(state.selectedCutIDs.concat(Array.isArray(action.cutID) ? action.cutID : [action.cutID]))
        ]
      };

    case REMOVE_SELECTED_CUT_ID:
      return {
        ...state,
        selectedCutIDs: state.selectedCutIDs.filter(cutID =>
          Array.isArray(action.cutID) ? !action.cutID.includes(cutID) : cutID !== action.cutID
        )
      };

    case GET_PRICING_DETAILS_RANGE_CHART_DATA_START:
      return {
        ...state,
        rangeChartLoading: true
      };
    case GET_PRICING_DETAILS_RANGE_CHART_DATA_SUCCESS:
      return {
        ...state,
        rangeChartLoading: false,
        rangeChartLoaded: true,
        rangeChartError: false,
        rangeChartData: action.rangeChartData
      };
    case GET_PRICING_DETAILS_RANGE_CHART_DATA_ERROR:
      return {
        ...state,
        rangeChartError: true,
        rangeChartLoading: false,
        rangeChartLoaded: false,
        rangeChartData: {}
      };
    default: {
      return {
        ...state
      };
    }
  }
}

export default combineReducers({
  MainJobPricingReducer: JobPricingReducer,
  JobPricingGridReducer,
  CompensationSummaryGridReducer
});
